import { api } from '../../../api/client';

const versionQuery = version => `?version=${encodeURIComponent(version)}`;

export const xsdTemplateApi = {
  getElements: (xsdId, version) =>
    api.get(`/build/xsd-templates/elements/${encodeURIComponent(xsdId)}${versionQuery(version)}`),
};
